import { render, staticRenderFns } from "./add-param-dialog.vue?vue&type=template&id=0ef386b3&scoped=true&"
import script from "./add-param-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-param-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef386b3",
  null
  
)

export default component.exports